// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"f5a7baae","453":"60f57826"}[chunkId] + ".chunk.js";
};